export enum OptionDialogType {
    CONFIRM = 1,
    INPUT = 2,
    MESSAGE = 3
}

// A translation key and its interpolation params
export interface OptionDialogText {
    key: string;
    params?: any;
}

export interface OptionDialogConfig {
    id?: string;
    type?: OptionDialogType;
    title: string;
    message?: string;
    value?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonClass?: string;
    // Optional lines shown before the message and the input
    descriptionLines?: OptionDialogText[];
    // Optional warning shown right before the input (or the buttons)
    warning?: OptionDialogText;
}

export interface InputDialogConfig {
    minlength?: number;
    maxlength?: number;

    chips?: any[];
}

export interface OptionDialogResult {

    onConfirmAction(callback: (value: any) => void): OptionDialogResult;

    onCancelAction(callback: (value: any) => void): OptionDialogResult;
}

export interface OptionDialog {

    // Asks a confirming question, like yes/no/cancel.
    showConfirmDialog(opts: OptionDialogConfig): OptionDialogResult;

    // Prompt for some input.
    showInputDialog(opts: OptionDialogConfig, inputOpts?: InputDialogConfig): OptionDialogResult;

    // Tell the user about something that has happened.
    showMessageDialog(opts: OptionDialogConfig): OptionDialogResult;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/option-dialog/option.dialog.ts